import React, { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GET_WEATHER_QUERY } from '../graphql/Queries';
import { FiSearch } from 'react-icons/fi';
import Loader from './Loader/Loader';
import Chart from './Chart';
import {
  InputGroup,
  Button,
  Container,
  FormControl,
  Table,
  Collapse,
} from 'react-bootstrap';

function WeatherPage() {
  const [result, setResult] = useState('');
  const [value, setValue] = useState('');
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [getCityByName, { data }] = useLazyQuery(GET_WEATHER_QUERY, {
    variables: { name: value },
  });
  function refreshPage() {
    window.location.reload(false);
  }
  const onClick = () => {
    if (result.length > 4) {
      getCityByName();
    } else {
      refreshPage();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(false);
    getCityByName({
      variables: {
        city: value,
      },
    });
  };

  const resetInputField = () => {
    setResult('');
  };

  return (
    <Container className='h-100 d-flex flex-column justify-content-center align-items-center'>
      <h2 className='mx-auto mb-4 mt-5 fw-lighter'>2022 Weather API</h2>
      <InputGroup className=' mb-3 w-50'>
        <FormControl
          aria-label='Input field'
          aria-describedby='basic-addon1'
          placeholder='Enter city name'
          value={result}
          onChange={(e) => setResult(e.target.value)}
        />

        <Button
          variant='outline-secondary'
          id='button-addon1'
          aria-label='Search city button'
          onClick={() => {
            setValue(result);
            getCityByName();
            onClick();
            handleSubmit.bind();
            resetInputField();
          }}
          className='inputButton'
        >
          <FiSearch />
        </Button>
      </InputGroup>

      {loading && <Loader />}
      {error && <p>Error</p>}
      {data && (
        <>
          <h3 className='fw-lighter mx-auto'>
            Weather in {data.getCityByName.name} {data.getCityByName.country}{' '}
            right now:
          </h3>
          <Table className='table w-50'>
            <tbody>
              <tr>
                <td>Temperature:</td>

                <td className='text-end'>
                  {Math.floor(
                    data.getCityByName.weather.temperature.actual - 273
                  ) + ' '}
                  °C
                </td>
              </tr>
              <tr>
                <td>Feels like:</td>
                <td className='text-end'>
                  {Math.floor(
                    data.getCityByName.weather.temperature.feelsLike - 273
                  ) + ' '}
                  Deg C
                </td>
              </tr>
              <tr>
                <td>Low temp:</td>
                <td className='text-end'>
                  {Math.floor(
                    data.getCityByName.weather.temperature.min - 273
                  ) + ' '}
                  Deg C
                </td>
              </tr>
              <tr>
                <td>High temp:</td>
                <td className='text-end'>
                  {Math.floor(
                    data.getCityByName.weather.temperature.max - 273
                  ) + ' '}
                  Deg C
                </td>
              </tr>
              <tr>
                <td>Description:</td>
                <td className='text-end'>
                  {data.getCityByName.weather.summary.description
                    .charAt(0)
                    .toUpperCase() +
                    data.getCityByName.weather.summary.description.slice(1)}
                </td>
              </tr>
            </tbody>
          </Table>

          <Button
            variant='outline-secondary'
            onClick={() => setOpen(!open)}
            aria-controls='example-collapse-text'
            aria-expanded={open}
            className='inputButton mt-3 mb-4'
          >
            Show further details
          </Button>
          <Collapse in={open}>
            <div id='example-collapse-text' className='w-50'>
              <Table>
                <tbody>
                  <tr>
                    <td>Wind speed:</td>

                    <td className='text-end'>
                      {data.getCityByName.weather.wind.speed + ' '} Kmh
                    </td>
                  </tr>
                  <tr>
                    <td>Cloud cover:</td>
                    <td className='text-end'>
                      {data.getCityByName.weather.clouds.all}%
                    </td>
                  </tr>
                  <tr>
                    <td>Visibility:</td>
                    <td className='text-end'>
                      {data.getCityByName.weather.clouds.visibility}m
                    </td>
                  </tr>
                  <tr>
                    <td>Humidity:</td>
                    <td className='text-end'>
                      {data.getCityByName.weather.clouds.humidity}%
                    </td>
                  </tr>
                  <tr>
                    <td>Sunrise:</td>
                    <td className='text-end'>
                      {data.getCityByName.weather.clouds.sunrise}
                      Morning
                    </td>
                  </tr>
                  <tr>
                    <td>Sunset:</td>
                    <td className='text-end'>
                      {data.getCityByName.weather.clouds.sunset}
                      Evening
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Collapse>
        </>
      )}

      <Chart />
    </Container>
  );
}
export default WeatherPage;
